export default [
    {
        path: '/communications/feedbacks-bot',
        name: 'communications-feedbacks-bot',
        component: () => import ('./views/FeedbackBotIndex'),
        meta: {
            title: 'Feedbacks registrados no bot',
            icon: 'mdi-chat-alert-outline',
            breadcrumbs: [
                { text: 'Lista de feedbacks registrados no bot', disabled: true }
            ]
        }
    },
]
